module.exports = __webpack_public_path__ + "media/images/pages/home_featured/home-contribute-icon-64dc4f0251c5467efb24ff30e8b8b86e.png";